import AppConstants from '@/common/constants/app.constants';
import { ErrorResponse } from '@/common/model/response/error-response.model';
import { GeneralDataResponse } from '@/common/model/response/general-response.data.model';
import { AxiosError, AxiosResponse } from 'axios';

export default class HTTPUtils {
  public static is401Error<T>(axiosGeneralResponse: AxiosResponse<GeneralDataResponse<T>>) {
    return axiosGeneralResponse?.data?.code === AppConstants.RESPONSE_401_ERROR_CODE;
  }

  /**
   * トークンの有効期限が切れているかどうかを確認します。
   * @param axiosErrorResponse Axios エラー応答
   * @returns トークンが期限切れの場合は true を返し、それ以外の場合は false を返します
   */
  public static isExpiredTokenError(axiosErrorResponse: AxiosError<ErrorResponse>) {
    return (
      axiosErrorResponse?.response?.status === AppConstants.RESPONSE_401_ERROR_CODE ||
      axiosErrorResponse?.message?.includes(AppConstants.RESPONSE_401_ERROR_MSG)
    );
  }

  public static isForbiddenResponse<T>(axiosGeneralResponse: AxiosResponse<GeneralDataResponse<T>>) {
    return axiosGeneralResponse?.data?.msg === AppConstants.RESPONSE_403_ERROR_MSG;
  }

  public static is500Error<T>(axiosGeneralResponse: AxiosError<ErrorResponse>) {
    return (
      axiosGeneralResponse?.response?.status === AppConstants.RESPONSE_500_ERROR_CODE ||
      ('' + axiosGeneralResponse).indexOf(AppConstants.RESPONSE_500_ERROR_MSG) !== -1
    );
  }

  public static is502Error<T>(axiosGeneralResponse: AxiosError<ErrorResponse>) {
    return (
      axiosGeneralResponse?.response?.status === AppConstants.RESPONSE_502_ERROR_CODE ||
      ('' + axiosGeneralResponse).indexOf(AppConstants.RESPONSE_502_ERROR_MSG) !== -1
    );
  }

  public static is504Error<T>(axiosGeneralResponse: AxiosError<ErrorResponse>) {
    return (
      axiosGeneralResponse?.code === '' + AppConstants.RESPONSE_504_ERROR_CODE ||
      ('' + axiosGeneralResponse).indexOf(AppConstants.RESPONSE_504_ERROR_MSG) !== -1
    );
  }
}
